import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dizhiguanli",
  "use": "icon-dizhiguanli-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-dizhiguanli\"><path d=\"M8.598 14.508c.81-.438 1.57-.96 2.271-1.556 1.982-1.696 3.162-3.781 3.195-6.292 0-3.06-2.698-5.573-6.064-5.573S1.936 3.6 1.936 6.657c.005 2.511 1.186 4.594 3.193 6.298a13.41 13.41 0 002.87 1.859c.202-.098.4-.2.597-.306h.002zM8 15.998S.863 13.217.849 6.66C.849 2.982 4.052 0 8 0s7.151 2.982 7.151 6.66C15.062 13.261 8 16 8 16v-.001zm-.016-7.002A2.112 2.112 0 105.852 6.88c0 1.167.955 2.115 2.133 2.115zm0 1.086a3.21 3.21 0 11.02-6.42 3.21 3.21 0 01-.02 6.42z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/dizhiguanli.svg
// module id = 456
// module chunks = 4